import { SVGProps } from "react";

const TruckIcon = ({
  width = 20,
  height = 20,
  color = "#3F8CFF",
  ...props
}: SVGProps<SVGSVGElement> & { color?: string }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.2727 6.36362H14.5454V2.72728H1.8182C0.813623 2.72728 0 3.5409 0 4.5455V14.5455H1.8182C1.8182 16.0501 3.04091 17.2727 4.54547 17.2727C6.05003 17.2727 7.27275 16.0501 7.27275 14.5455H12.7273C12.7273 16.0501 13.95 17.2727 15.4546 17.2727C16.9591 17.2727 18.1818 16.0501 18.1818 14.5455H20V10L17.2727 6.36362ZM4.54547 15.9091C3.79091 15.9091 3.18183 15.3 3.18183 14.5455C3.18183 13.7909 3.79091 13.1818 4.54547 13.1818C5.30003 13.1818 5.90911 13.7909 5.90911 14.5455C5.90911 15.3 5.29999 15.9091 4.54547 15.9091ZM15.4546 15.9091C14.7 15.9091 14.0909 15.3 14.0909 14.5455C14.0909 13.7909 14.7 13.1818 15.4546 13.1818C16.2091 13.1818 16.8182 13.7909 16.8182 14.5455C16.8182 15.3 16.2091 15.9091 15.4546 15.9091ZM14.5454 10V7.72728H16.8182L18.6045 10H14.5454Z"
      fill={color}
    />
  </svg>
);

export default TruckIcon;
